var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    className: "bg"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46628 10.6666C6.49721 10.6666 7.33294 11.5023 7.33294 12.5332C7.33294 13.5642 6.49721 14.3999 5.46628 14.3999C4.43534 14.3999 3.59961 13.5642 3.59961 12.5332C3.59961 11.5023 4.43534 10.6666 5.46628 10.6666ZM12.0003 10.6666C13.0313 10.6666 13.867 11.5023 13.867 12.5332C13.867 13.5642 13.0313 14.3999 12.0003 14.3999C10.9694 14.3999 10.1337 13.5642 10.1337 12.5332C10.1337 11.5023 10.9694 10.6666 12.0003 10.6666ZM20.3994 12.5332C20.3994 11.5023 19.5637 10.6666 18.5328 10.6666C17.5018 10.6666 16.6661 11.5023 16.6661 12.5332C16.6661 13.5642 17.5018 14.3999 18.5328 14.3999C19.5637 14.3999 20.3994 13.5642 20.3994 12.5332Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.8a4eea571b8a0815c63846543f559a8e.svg";
export { ForwardRef as ReactComponent };